/* Reduced Fares pop-up box behavior */
$(document).on('click', '.reduced-fares',function(){
	var $fareBtn = $(this);
	$('#reduced-fares-box').stop(true,true).slideToggle(150,'swing',function(){
		var $reducedFaresBox = $('#reduced-fares-box');
		if ($('.lt-ie8').length > 0){
			$reducedFaresBox.css('display','inline');
		}
		$reducedFaresBox.css('overflow','visible');
		$('#reduced-fares-box > .close-btn').fadeIn('fast');
		if($reducedFaresBox.is(':visible')) {
			$reducedFaresBox.focus();
			$reducedFaresBox.attr('aria-hidden',false);
		}else {
			$fareBtn.focus();
		}
	});
});

var dataStore = (function(){
	var products;
	function load(form){
		$.ajax({
				   type: 'POST',
				   async: false,
				   url: '/find/json/getJsonProducts.do',
				   dataType: 'json',
				   data: form.serialize()
			   }).done(function(result) {
			if(result.status == 'success'){
				products = result.data;
			}else{
				products = null;
			}
		});
	}
	return {
		load : function(form) {
			load(form);
		},
		isExists: function(){
			if(products){
				var firstId=Object.keys(products)[0];
				return firstId && firstId.length > 4;
			}
			return false;
		},
		getData: function(){
			return products;
		}
	}
})();

/* Reduced Fares check box behavior */
$(document).on('change','#reduced-fares-checkbox',function(){
	if($(this).is(':checked')){
		document.cookie = 'cwp' + "=" + escape($(this).is(':checked') ? 'true' : 'false') + "; " + "path=/; domain=.princess.com; ";
	}else{
		deleteCokie("cwp","/",".princess.com");
	}
	$('#reduced-fares-box > .close-btn').trigger('click');
});

$(document).on('click','#reduced-fares-box > .close-btn',function(){
	$(this).fadeOut('fast','swing',function(){
		var $reducedFareBox = $('#reduced-fares-box');
		$reducedFareBox.stop(true,true).slideToggle(150,'swing');
		$reducedFareBox.attr('aria-hidden',true);
		$(document).find('#reduced-fare-btn').focus();
	});
});

$(document).on('change','#form-fields select', function() {
	filterWidgets(dataStore.getData());
	//setDateHiddenValue();
});

$(document).on('click', '#view-results', function(e){
	e.preventDefault();
	
	if(!$(this).hasClass('deactive')){
		$(this).addClass('deactive');
		trackSearch();
		//setDateHiddenValue();
		$("#searchWidgetForm").submit();
	}
});

function trackSearch()
{
	var selTrade = $("#destination option:selected");
	var selMonth = $("#month option:selected");
	var selPort = $('#port option:selected');
	var selDuration = $('#duration option:selected');
	var filterCat = '';
	var selections = '';
	var searchType = 'Basic:cruise';
	var dateList = '';
	var bookingType = 'n/a';
	
	var trackObject = {
		'event': 'cruise-widget-search-submit',
		'filterCategorySel': "",
		'searchTypeCategory': searchType,
		'dateList': "",
		'bookingType': bookingType
	};
	
	// month
	if (selMonth.val())
	{
		filterCat += 'month/year|';
		trackObject["cruiseDateFrom"] = selMonth.text().split(' ').join('');
		trackObject["dateList"] = selMonth.text().split(' ').join('');
	}
	
	// trade
	if (selTrade.val())
	{
		filterCat += 'destination|';
		trackObject["destName"] = selTrade.text();
	}
	
	// departure
	if (selPort.val())
	{
		filterCat += 'departure/end_port|';
		trackObject["depPortName"] = selPort.text();
	}
	
	// length
	if (selDuration.val())
	{
		filterCat += 'duration|';
		trackObject["lengthOfCruiseFilter"] = selDuration.text().split(' ').join('');
	}
	
	trackObject["filterCategorySel"] = filterCat;
	
	if (typeof window.dtm_dataLayer == 'object')
	{
		window.dtm_dataLayer.push(trackObject);
	}
}


function setDateHiddenValue(){
	var month = $("#month option:selected").val();
	var year =  $("#year option:selected").val();
	var count = 0;
	if(month.length > 0 && year.length > 0){
		$('#ube-month-0').val(month+year);
		count=1;
	}else if(month.length > 0){
		$("#year option:not([value=])").each(function(i){
			if(!$(this).parent('span').hasClass('hide')){
				$('#ube-month-'+count).val(month+$(this).val());
				count++;
			}
		});
	}else if(year.length > 0){
		$("#month option:not([value=])").each(function(i){
			if(!$(this).parent('span').hasClass('hide')){
				$('#ube-month-'+count).val($(this).val()+year);
				count++;
			}
		});
	}
	for (count; count < $("#month option:not([value=])").length; count++){
		$('#ube-month-'+count).val('');
	}
}
function getWidgetData(elementId, formData){
	$.ajax({
			   type : 'POST',
			   url:  '/find/searchWidget.do',
			   data : formData,
			   dataType: 'html',
			   context: document.body
		   }).done(function(data) {
		var formElement = $(data).filter('#searchWidgetForm')
		resElement = $(data).filter('.res-find');
		if(formData != ''){
			$('#'+elementId).html(formElement.find('#'+elementId).html());
		} else {
			$('#'+elementId).html(data);
		}
		dataStore.load($('#searchWidgetForm'));
		if(dataStore.isExists()){
			filterWidgets(dataStore.getData());
		}
		$('#promo-block').prepend(resElement);
	});
}
function filterWidgets(json){
	var $selTrade = $("#destination option:selected"), $selMonth = $("#month option:selected"),
		$selPort = $('#port option:selected'), $selDuration = $('#duration option:selected');
	$matchDates='',	$matchTrades='',$matchPorts='',$matchDuration='';
	$.each(json, function(key,value){
		var isMatch = true;
		var dropdownMatch = "MDVP";	//M:Trade, D:Month & Year, P:Emberk/Disemberk Port & V:Duration.
		if(value['D'] && $selMonth.length > 0 && $selMonth.val().length > 0){
			if(value['D'].search($selMonth.val()) == -1){
				dropdownMatch = "D";
				isMatch = false;
			}
		}
		if(value['M'] && $selTrade.length > 0 && $selTrade.val().length > 0){
			if(value['M'].search($selTrade.val()) == -1){
				dropdownMatch = isMatch ? "M" : "";
				isMatch = false;
			}
		}
		if($selDuration.length > 0 && $selDuration.val().length > 0){
			if (value['V'] && value['V'].search($selDuration.val()) == -1){
				dropdownMatch = isMatch ? "V" : "";
				isMatch = false;
			}
		}
		if($selPort.length > 0 && $selPort.val().length > 0){
			if(value['P'] && value['P'].search($selPort.val()) == -1){
				dropdownMatch = isMatch ? "P" : "";
				isMatch = false;
			}
		}
		if(value['D'] && dropdownMatch.indexOf('D') >= 0){
			$matchDates += value['D']+',';
		}
		if(value['M'] && dropdownMatch.indexOf('M') >= 0){
			$matchTrades += value['M']+',';
		}
		if(value['P'] && dropdownMatch.indexOf('P') >= 0){
			$matchPorts += value['P']+',';
		}
		if(value['V'] && dropdownMatch.indexOf('V') >= 0){
			$matchDuration += value['V']+',';
		}
	});
	
	filterWidgetDropDowns();
}

function filterWidgetDropDowns(){
	$("#destination option").each(function() {
		if($(this).val()){
			if($matchTrades.search($(this).val()) >= 0){
				$(this).parent('span').contents().unwrap();
			}else if(!$(this).parent('span').hasClass('hide')){
				$(this).wrap('<span class="hide"></span>');
			}
		}
	});
	$('#month option').each(function() {
		if($(this).val()){
			if($matchDates.search($(this).val()) >= 0){
				$(this).parent('span').contents().unwrap();
			}else if(!$(this).parent('span').hasClass('hide')){
				$(this).wrap('<span class="hide"></span>');
			}
		}
	});
	$('#port option').each(function() {
		if($(this).val()){
			if($matchPorts.search($(this).val()) >= 0){
				$(this).parent('span').contents().unwrap();
			}else if(!$(this).parent('span').hasClass('hide')){
				$(this).wrap('<span class="hide"></span>');
			}
		}
	});
	$('#duration option').each(function() {
		if($(this).val()){
			if($matchDuration.search($(this).val()) >= 0){
				$(this).parent('span').contents().unwrap();
			}else if(!$(this).parent('span').hasClass('hide')){
				$(this).wrap('<span class="hide"></span>');
			}
		}
	});
}
